// Custom JS
$(document).ready(function() {
    $('.news_rotator').l3harrisNewsRotator();

    // // Make Boostrap 5 honor link and open on hover.
    // $('.dropdown-hover').each(function() {
    //     const dropdownElement = $(this).find('.dropdown-toggle');
    //     const dropdown = new bootstrap.Dropdown(dropdownElement);

    //     $(this).mouseenter(function() {
    //         dropdown.show();
    //     });
    //     $(this).mouseleave(function() {
    //         dropdown.hide();
    //     });
    // });

    $('.accordion').find('.pane').each(function() {
        $(this).hide();
    });

    //The click to hide function
    var suffix = "2-open";
    $(".trigger").click(function() {
        if ($(this).hasClass("current") && $(this).parent().next().queue().length === 0) {
            $(this).parent().next().slideUp();
            console.log('208-close');
            $(this).removeClass("current");
            $(this).children('i').removeClass('bi-folder'+suffix);
        } else if (!$(this).hasClass("current") && $(this).parent().next().queue().length === 0) {
            console.log('221-Open');
            $(this).parent().next().slideDown();
            $(this).children('i').removeClass('bi-folder'+suffix).addClass('bi-folder'+suffix);
            $(this).addClass("current");
        }
    });

    //copyright notification and link in bottom-menu
    $('<li class="nav-item"><a href="https://www.l3harris.com" target="_blank">&copy; '+new Date().getFullYear()+' L3Harris Technologies, Inc.</a></li>').appendTo('ul.bottom-menu')
});